module.exports = __webpack_public_path__ + "img/follow_btn.b5d43197.svg";